export interface BaseModel {
    id: number;
    createdDate: string;
    modifiedDate?: string;
    createdById?: number;
    modifiedById?: number;
}

export interface SiteBaseModel extends BaseModel {
    isActiveRecord: boolean;
    name: string;
    fullName: string;
    bpLocationId: number;
    state: string;
    bpsid: number;
    automedSiteId?: number;
    umbracoSiteId: string;
}

export interface AutomedDetails {
    centerName: string;
    locationDisplayName: string;
    confirmAppInfo: string;
    confirmAppHolidayInfo: string;
    futureApptWeeks: number;
}

export const enum ConfigFlagEnum {
    SelfCheckinFluPrescreening = 1,
    EnableAutomedScripts = 2,
    EnableAutomedReferrals = 3,
    AutomedUrlPath = 4,
}

export interface SiteConfig {
    value?: number;
    defaultValue?: number;
    textValue?: string;
    defaultTextValue?: string;
    id: ConfigFlagEnum;
    description: string;
}
